/*************************************************/
/* Full Text Search                              */
/*************************************************/

export function search() {
    const suggestionsSelector = '.search-suggestions';
    const searchFormSelector = '.search-form'; // Use class selector
    let typeTimer;

    // Function to get and display search results for a specific form
    const getAndDisplaySearchResults = function (query, formElement) {
        const endpointUrl = formElement.getAttribute("action");
        fetch(`${endpointUrl}?altTemplate=searchSuggestions&q=${encodeURIComponent(query)}`)
            .then(response => response.text())
            .then(data => {
                // Remove any existing suggestions
                const existingSuggestions = formElement.querySelector(suggestionsSelector);
                if (existingSuggestions) {
                    existingSuggestions.remove();
                }

                // Create a container for the new suggestions
                const suggestionsContainer = document.createElement('div');
                suggestionsContainer.classList.add(suggestionsSelector.replace('.', '')); // Add the class without the dot
                suggestionsContainer.innerHTML = data;
                formElement.appendChild(suggestionsContainer);

                // Show the suggestions
                suggestionsContainer.style.display = 'block';
            })
            .catch(error => console.error('Error fetching search results:', error));
    };

    // Initialize the search functionality
    const init = function () {

        //If we are using an external search, dont attach any listeners
        if(document.body.classList.contains('external-search')) {
            return false;
        }

        // Select all forms with the class "search-form"
        const searchForms = document.querySelectorAll(searchFormSelector);

        // Iterate over each form and attach event listeners
        searchForms.forEach(function (form) {
            const input = form.querySelector('input');

            // Listen for keyup events on the input
            input.addEventListener('keyup', function () {
                if (form.getAttribute("data-show-suggestions") === "False") return;

                // Remove any existing suggestions
                const existingSuggestions = form.querySelector(suggestionsSelector);
                if (existingSuggestions) {
                    existingSuggestions.remove();
                }

                const query = this.value;
                clearTimeout(typeTimer);

                // Delay the search to prevent excessive requests
                typeTimer = setTimeout(function () {
                    if (query.trim() !== "") {
                        getAndDisplaySearchResults(query, form);
                    }
                }, 500);
            });
        });

        // Hide suggestions when clicking outside the suggestions box
        document.addEventListener('click', function (e) {
            const clickTarget = e.target;

            // Check if the click is outside any suggestion box
            const allSuggestions = document.querySelectorAll(suggestionsSelector);
            allSuggestions.forEach(suggestionsBox => {
                if (!suggestionsBox.contains(clickTarget)) {
                    suggestionsBox.remove();
                }
            });
        });
    };

    init();
}
